module.exports = __webpack_public_path__ + "img/配电房监控1.9871ce12.png";